import { render, staticRenderFns } from "./NgoUserView.vue?vue&type=template&id=d536e9fe&"
import script from "./NgoUserView.vue?vue&type=script&lang=js&"
export * from "./NgoUserView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports